import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var RefreshCw03 = function RefreshCw03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M14 22s.8492-.1213 4.364-3.636c3.5147-3.5148 3.5147-9.2132 0-12.728C17.1187 4.3908 15.5993 3.5867 14 3.2238M14 22h6m-6 0v-6M10 2.0002s-.8492.1213-4.364 3.636c-3.5147 3.5148-3.5147 9.2132 0 12.728 1.2453 1.2452 2.7647 2.0493 4.364 2.4122m0-18.7762L4 2m6 .0002V8"
    })
  }));
};
export default RefreshCw03;